/**
 * Forces /blog-draft-preview/* through a real server render.
 *
 * Draft content is fetched with the Hygraph credential, which can write to the
 * CMS and therefore stays on the server (see server-middleware/hygraph.js). The
 * browser-facing proxy deliberately serves PUBLISHED only, so asyncData running
 * client-side — which is what a <nuxt-link> transition does — would come back
 * with no drafts.
 *
 * Rather than let the review tool silently show an empty list, a client-side
 * navigation into these routes is turned into a full page load, which puts
 * asyncData back on the server where the draft token lives. Nuxt runs route
 * middleware on the server for the initial request and in the browser only for
 * subsequent navigations, so the process.client guard fires exactly then.
 *
 * The cost is a page reload when moving between the draft index and a draft
 * article. That is acceptable for an internal, dealer-admin-only tool; the
 * public blog is unaffected and still navigates client-side.
 */
export default function ({ route }) {
  if (process.client) {
    window.location.assign(route.fullPath);
  }
}
